"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsSQLite = void 0;
const SQLITE_OPEN_READONLY = 1;
class UtilsSQLite {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        //    this.JSQlite = require('@journeyapps/sqlcipher').verbose();
        this.SQLite3 = require('sqlite3');
    }
    /**
     * OpenOrCreateDatabase
     * @param pathDB
     * @param password
     */
    async openOrCreateDatabase(pathDB /*,
    password: string,*/, readonly) {
        const msg = 'OpenOrCreateDatabase: ';
        // open sqlite3 database
        let mDB;
        if (!readonly) {
            mDB = new this.SQLite3.Database(pathDB, {
                verbose: console.log,
            });
        }
        else {
            mDB = new this.SQLite3.Database(pathDB, SQLITE_OPEN_READONLY, {
                verbose: console.log,
            });
        }
        if (mDB != null) {
            try {
                await this.dbChanges(mDB);
            }
            catch (err) {
                return Promise.reject(msg + `dbChanges ${err}`);
            }
            try {
                /*        // set the password
                if (password.length > 0) {
                  await this.setCipherPragma(mDB, password);
                }
                */
                // set Foreign Keys On
                await this.setForeignKeyConstraintsEnabled(mDB, true);
            }
            catch (err) {
                return Promise.reject(msg + `${err}`);
            }
            return Promise.resolve(mDB);
        }
        else {
            return Promise.reject(msg + 'open database failed');
        }
    }
    /**
     * SetCipherPragma
     * @param mDB
     * @param password
     */
    /*
    public async setCipherPragma(mDB: any, password: string): Promise<void> {
      return new Promise((resolve, reject) => {
        mDB.serialize(() => {
          mDB.run('PRAGMA cipher_compatibility = 4');
          mDB.run(`PRAGMA key = '${password}'`, (err: any) => {
            if (err) {
              reject(new Error('SetForeignKey: ' + `${err.message}`));
            }
            resolve();
          });
        });
      });
    }
  */
    /**
     * SetForeignKeyConstraintsEnabled
     * @param mDB
     * @param toggle
     */
    async setForeignKeyConstraintsEnabled(mDB, toggle) {
        return new Promise((resolve, reject) => {
            let key = 'OFF';
            if (toggle) {
                key = 'ON';
            }
            mDB.run(`PRAGMA foreign_keys = '${key}'`, (err) => {
                if (err) {
                    reject(`SetForeignKey: ${err.message}`);
                }
                resolve();
            });
        });
    }
    /**
     * GetVersion
     * @param mDB
     */
    async getVersion(mDB) {
        return new Promise((resolve, reject) => {
            let version = 0;
            const SELECT_VERSION = 'PRAGMA user_version;';
            mDB.get(SELECT_VERSION, [], (err, row) => {
                // process the row here
                if (err) {
                    reject('getVersion failed: ' + `${err.message}`);
                }
                else {
                    if (row == null) {
                        version = 0;
                    }
                    else {
                        const key = Object.keys(row)[0];
                        version = row[key];
                    }
                    resolve(version);
                }
            });
        });
    }
    /**
     * SetVersion
     * @param mDB
     * @param version
     */
    async setVersion(mDB, version) {
        return new Promise((resolve, reject) => {
            mDB.run(`PRAGMA user_version = ${version}`, (err) => {
                if (err) {
                    reject('setVersion failed: ' + `${err.message}`);
                }
                resolve();
            });
        });
    }
    /**
     * ChangePassword
     * @param pathDB
     * @param password
     * @param newpassword
     */
    /*
  
    public async changePassword(
      pathDB: string,
      password: string,
      newpassword: string,
    ): Promise<void> {
      let mDB: any;
      try {
        mDB = await this.openOrCreateDatabase(pathDB, password);
        await this.pragmaReKey(mDB, password, newpassword);
      } catch (err) {
        return Promise.reject(err);
      } finally {
        mDB.close();
      }
    }
  */
    /**
     * PragmaReKey
     * @param mDB
     * @param password
     * @param newpassword
     */
    /*
    private async pragmaReKey(
      mDB: any,
      password: string,
      newpassword: string,
    ): Promise<void> {
      return new Promise((resolve, reject) => {
        mDB.serialize(() => {
          mDB.run('PRAGMA cipher_compatibility = 4');
          mDB.run(`PRAGMA key = '${password}'`);
          mDB.run(`PRAGMA rekey = '${newpassword}'`, (err: any) => {
            if (err) {
              reject(new Error('ChangePassword: ' + `${err.message}`));
            }
            resolve();
          });
        });
      });
    }
  */
    /**
     * BeginTransaction
     * @param db
     * @param isOpen
     */
    async beginTransaction(db, isOpen) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise((resolve, reject) => {
            const msg = 'BeginTransaction: ';
            if (!isOpen) {
                return Promise.reject(`${msg}database not opened`);
            }
            const sql = 'BEGIN TRANSACTION;';
            db.run(sql, (err) => {
                if (err) {
                    reject(`${msg}${err.message}`);
                }
                resolve();
            });
        });
    }
    /**
     * RollbackTransaction
     * @param db
     * @param isOpen
     */
    async rollbackTransaction(db, isOpen) {
        return new Promise((resolve, reject) => {
            const msg = 'RollbackTransaction: ';
            if (!isOpen) {
                reject(`${msg}database not opened`);
            }
            const sql = 'ROLLBACK TRANSACTION;';
            db.run(sql, (err) => {
                if (err) {
                    reject(`${msg}${err.message}`);
                }
                resolve();
            });
        });
    }
    /**
     * CommitTransaction
     * @param db
     * @param isOpen
     */
    async commitTransaction(db, isOpen) {
        return new Promise((resolve, reject) => {
            const msg = 'CommitTransaction: ';
            if (!isOpen) {
                reject(`${msg}database not opened`);
            }
            const sql = 'COMMIT TRANSACTION;';
            db.run(sql, (err) => {
                if (err) {
                    reject(`${msg}${err.message}`);
                }
                resolve();
            });
        });
    }
    /**
     * DbChanges
     * return total number of changes
     * @param db
     */
    async dbChanges(db) {
        return new Promise((resolve, reject) => {
            const SELECT_CHANGE = 'SELECT total_changes()';
            let changes = 0;
            db.get(SELECT_CHANGE, [], (err, row) => {
                // process the row here
                if (err) {
                    reject(`DbChanges failed: ${err.message}`);
                }
                else {
                    if (row == null) {
                        changes = 0;
                    }
                    else {
                        const key = Object.keys(row)[0];
                        changes = row[key];
                    }
                    resolve(changes);
                }
            });
        });
    }
    /**
     * GetLastId
     * @param db
     */
    getLastId(db) {
        return new Promise((resolve, reject) => {
            const SELECT_LAST_ID = 'SELECT last_insert_rowid()';
            let lastId = -1;
            db.get(SELECT_LAST_ID, [], (err, row) => {
                // process the row here
                if (err) {
                    reject(`GetLastId failed: ${err.message}`);
                }
                else {
                    if (row == null)
                        resolve(lastId);
                    const key = Object.keys(row)[0];
                    lastId = row[key];
                    resolve(lastId);
                }
            });
        });
    }
    /**
     * Execute
     * @param mDB
     * @param sql
     */
    async execute(mDB, sql, fromJson) {
        let changes = -1;
        let initChanges = -1;
        try {
            initChanges = await this.dbChanges(mDB);
            let sqlStmt = sql;
            // Check for DELETE FROM in sql string
            if (!fromJson &&
                sql.toLowerCase().includes('DELETE FROM'.toLowerCase())) {
                sqlStmt = sql.replace(/\n/g, '');
                const sqlStmts = sqlStmt.split(';');
                const resArr = [];
                for (const stmt of sqlStmts) {
                    const trimStmt = stmt
                        .trim()
                        .substring(0, Math.min(stmt.trim().length, 11))
                        .toUpperCase();
                    if (trimStmt === 'DELETE FROM' &&
                        stmt.toLowerCase().includes('WHERE'.toLowerCase())) {
                        const whereStmt = `${stmt.trim()};`;
                        const rStmt = await this.deleteSQL(mDB, whereStmt, []);
                        resArr.push(rStmt);
                    }
                    else {
                        resArr.push(stmt);
                    }
                }
                sqlStmt = resArr.join(';');
            }
            await this.execDB(mDB, sqlStmt);
            changes = (await this.dbChanges(mDB)) - initChanges;
            return Promise.resolve(changes);
        }
        catch (err) {
            const msg = err.message ? err.message : err;
            return Promise.reject(`Execute: ${msg}`);
        }
    }
    /**
     * ExecDB
     * @param mDB
     * @param sql
     */
    async execDB(mDB, sql) {
        return new Promise((resolve, reject) => {
            mDB.exec(sql, async (err) => {
                if (err) {
                    console.log(`in execDB err: ${JSON.stringify(err)}`);
                    reject(`Execute: ${err}: `);
                }
                resolve();
            });
        });
    }
    /**
     * ExecuteSet
     * @param db
     * @param set
     */
    async executeSet(db, set, fromJson) {
        let lastId = -1;
        for (let i = 0; i < set.length; i++) {
            const statement = 'statement' in set[i] ? set[i].statement : null;
            const values = 'values' in set[i] && set[i].values.length > 0 ? set[i].values : [];
            if (statement == null) {
                let msg = 'ExecuteSet: Error Nostatement';
                msg += ` for index ${i}`;
                return Promise.reject(msg);
            }
            try {
                if (Array.isArray(values[0])) {
                    for (const val of values) {
                        const mVal = await this.replaceUndefinedByNull(val);
                        lastId = await this.prepareRun(db, statement, mVal, fromJson);
                    }
                }
                else {
                    const mVal = await this.replaceUndefinedByNull(values);
                    lastId = await this.prepareRun(db, statement, mVal, fromJson);
                }
            }
            catch (err) {
                return Promise.reject(`ExecuteSet: ${err}`);
            }
        }
        return Promise.resolve(lastId);
    }
    /**
     * PrepareRun
     * @param db
     * @param statement
     * @param values
     */
    async prepareRun(db, statement, values, fromJson) {
        const stmtType = statement
            .replace(/\n/g, '')
            .trim()
            .substring(0, 6)
            .toUpperCase();
        let sqlStmt = statement;
        let lastId = -1;
        try {
            if (!fromJson && stmtType === 'DELETE') {
                sqlStmt = await this.deleteSQL(db, statement, values);
            }
            let mVal = [];
            if (values != null && values.length > 0) {
                mVal = await this.replaceUndefinedByNull(values);
            }
            await this.runExec(db, sqlStmt, mVal);
            lastId = await this.getLastId(db);
            return Promise.resolve(lastId);
        }
        catch (err) {
            return Promise.reject(`PrepareRun: ${err}`);
        }
    }
    async runExec(db, stmt, values = []) {
        return new Promise((resolve, reject) => {
            if (values != null && values.length > 0) {
                ``;
                db.run(stmt, values, (err) => {
                    if (err) {
                        console.log(`in runExec err1: ${JSON.stringify(err)}`);
                        const msg = err.message ? err.message : err;
                        reject(msg);
                    }
                    else {
                        resolve();
                    }
                });
            }
            else {
                db.exec(stmt, (err) => {
                    if (err) {
                        console.log(`in runExec err2: ${JSON.stringify(err)}`);
                        const msg = err.message ? err.message : err;
                        reject(msg);
                    }
                    else {
                        resolve();
                    }
                });
            }
        });
    }
    /**
     * replaceUndefinedByNull
     * @param values
     * @returns
     */
    async replaceUndefinedByNull(values) {
        const retValues = [];
        if (values.length > 0) {
            for (const val of values) {
                let mVal = val;
                if (typeof val === 'undefined')
                    mVal = null;
                retValues.push(mVal);
            }
        }
        return Promise.resolve(retValues);
    }
    /**
     * deleteSQL
     * @param db
     * @param statement
     * @param values
     * @returns
     */
    async deleteSQL(db, statement, values) {
        let sqlStmt = statement;
        try {
            const isLast = await this.isLastModified(db, true);
            const isDel = await this.isSqlDeleted(db, true);
            if (isLast && isDel) {
                // Replace DELETE by UPDATE and set sql_deleted to 1
                const wIdx = statement.toUpperCase().indexOf('WHERE');
                const preStmt = statement.substring(0, wIdx - 1);
                const clauseStmt = statement.substring(wIdx, statement.length);
                const tableName = preStmt
                    .substring('DELETE FROM'.length)
                    .trim();
                sqlStmt = `UPDATE ${tableName} SET sql_deleted = 1 ${clauseStmt}`;
                // Find REFERENCES if any and update the sql_deleted column
                await this.findReferencesAndUpdate(db, tableName, clauseStmt, values);
            }
            return sqlStmt;
        }
        catch (err) {
            return Promise.reject(`DeleteSQL: ${err}`);
        }
    }
    /**
     * findReferencesAndUpdate
     * @param db
     * @param tableName
     * @param whereStmt
     * @param values
     * @returns
     */
    async findReferencesAndUpdate(db, tableName, whereStmt, values) {
        try {
            const references = await this.getReferences(db, tableName);
            if (references.length <= 0) {
                return;
            }
            const tableNameWithRefs = references.pop();
            for (const refe of references) {
                // get the tableName of the reference
                const refTable = await this.getReferenceTableName(refe);
                if (refTable.length <= 0) {
                    continue;
                }
                // get the with references columnName
                const withRefsNames = await this.getWithRefsColumnName(refe);
                if (withRefsNames.length <= 0) {
                    continue;
                }
                // get the referenced columnName
                const colNames = await this.getReferencedColumnName(refe);
                if (colNames.length <= 0) {
                    continue;
                }
                // update the where clause
                const uWhereStmt = await this.updateWhere(whereStmt, withRefsNames, colNames);
                if (uWhereStmt.length <= 0) {
                    continue;
                }
                let updTableName = tableNameWithRefs;
                let updColNames = colNames;
                if (tableNameWithRefs === tableName) {
                    updTableName = refTable;
                    updColNames = withRefsNames;
                }
                //update sql_deleted for this reference
                const stmt = 'UPDATE ' + updTableName + ' SET sql_deleted = 1 ' + uWhereStmt;
                if (values != null && values.length > 0) {
                    const mVal = await this.replaceUndefinedByNull(values);
                    let arrVal = whereStmt.split('?');
                    if (arrVal[arrVal.length - 1] === ';')
                        arrVal = arrVal.slice(0, -1);
                    const selValues = [];
                    for (const [j, val] of arrVal.entries()) {
                        for (const updVal of updColNames) {
                            const idxVal = val.indexOf(updVal);
                            if (idxVal > -1) {
                                selValues.push(mVal[j]);
                            }
                        }
                    }
                    await db.run(stmt, selValues);
                }
                else {
                    await db.exec(stmt);
                }
                const lastId = await this.getLastId(db);
                if (lastId == -1) {
                    const msg = `UPDATE sql_deleted failed for references table: ${refTable}`;
                    return Promise.reject(new Error(`findReferencesAndUpdate: ${msg}`));
                }
            }
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(new Error(`findReferencesAndUpdate: ${err.message}`));
        }
    }
    async getReferenceTableName(refValue) {
        let tableName = '';
        if (refValue.length > 0) {
            const arr = refValue.split(new RegExp('REFERENCES', 'i'));
            if (arr.length === 2) {
                const oPar = arr[1].indexOf('(');
                tableName = arr[1].substring(0, oPar).trim();
            }
        }
        return tableName;
    }
    async getReferencedColumnName(refValue) {
        let colNames = [];
        if (refValue.length > 0) {
            const arr = refValue.split(new RegExp('REFERENCES', 'i'));
            if (arr.length === 2) {
                const oPar = arr[1].indexOf('(');
                const cPar = arr[1].indexOf(')');
                const colStr = arr[1].substring(oPar + 1, cPar).trim();
                colNames = colStr.split(',');
            }
        }
        return colNames;
    }
    async getWithRefsColumnName(refValue) {
        let colNames = [];
        if (refValue.length > 0) {
            const arr = refValue.split(new RegExp('REFERENCES', 'i'));
            if (arr.length === 2) {
                const oPar = arr[0].indexOf('(');
                const cPar = arr[0].indexOf(')');
                const colStr = arr[0].substring(oPar + 1, cPar).trim();
                colNames = colStr.split(',');
            }
        }
        return colNames;
    }
    async updateWhere(whStmt, withRefsNames, colNames) {
        let whereStmt = '';
        if (whStmt.length > 0) {
            const index = whStmt.toLowerCase().indexOf('WHERE'.toLowerCase());
            const stmt = whStmt.substring(index + 6);
            if (withRefsNames.length === colNames.length) {
                for (let i = 0; i < withRefsNames.length; i++) {
                    let colType = 'withRefsNames';
                    let idx = stmt.indexOf(withRefsNames[i]);
                    if (idx === -1) {
                        idx = stmt.indexOf(colNames[i]);
                        colType = 'colNames';
                    }
                    if (idx > -1) {
                        let valStr = '';
                        const fEqual = stmt.indexOf('=', idx);
                        if (fEqual > -1) {
                            const iAnd = stmt.indexOf('AND', fEqual);
                            const ilAnd = stmt.indexOf('and', fEqual);
                            if (iAnd > -1) {
                                valStr = stmt.substring(fEqual + 1, iAnd - 1).trim();
                            }
                            else if (ilAnd > -1) {
                                valStr = stmt.substring(fEqual + 1, ilAnd - 1).trim();
                            }
                            else {
                                valStr = stmt.substring(fEqual + 1, stmt.length).trim();
                            }
                            if (i > 0) {
                                whereStmt += ' AND ';
                            }
                            if (colType === 'withRefsNames') {
                                whereStmt += `${colNames[i]} = ${valStr}`;
                            }
                            else {
                                whereStmt += `${withRefsNames[i]} = ${valStr}`;
                            }
                        }
                    }
                }
                whereStmt = 'WHERE ' + whereStmt;
            }
        }
        return whereStmt;
    }
    async getReferences(db, tableName) {
        const sqlStmt = 'SELECT sql FROM sqlite_master ' +
            "WHERE sql LIKE('%FOREIGN KEY%') AND sql LIKE('%REFERENCES%') AND " +
            "sql LIKE('%" +
            tableName +
            "%') AND sql LIKE('%ON DELETE%');";
        try {
            const res = await this.queryAll(db, sqlStmt, []);
            // get the reference's string(s)
            let retRefs = [];
            if (res.length > 0) {
                retRefs = await this.getRefs(res[0].sql);
            }
            return Promise.resolve(retRefs);
        }
        catch (err) {
            return Promise.reject(new Error(`getReferences: ${err.message}`));
        }
    }
    async getRefs(str) {
        const retRefs = [];
        const arrFor = str.split(new RegExp('FOREIGN KEY', 'i'));
        // Loop through Foreign Keys
        for (let i = 1; i < arrFor.length; i++) {
            retRefs.push(arrFor[i].split(new RegExp('ON DELETE', 'i'))[0].trim());
        }
        // find table name with references
        if (str.substring(0, 12).toLowerCase() === 'CREATE TABLE'.toLowerCase()) {
            const oPar = str.indexOf('(');
            const tableName = str.substring(13, oPar).trim();
            retRefs.push(tableName);
        }
        return retRefs;
    }
    /**
     * QueryAll
     * @param mDB
     * @param sql
     * @param values
     */
    queryAll(mDB, sql, values) {
        return new Promise((resolve, reject) => {
            mDB.serialize(() => {
                mDB.all(sql, values, (err, rows) => {
                    if (err) {
                        reject(`QueryAll: ${err.message}`);
                    }
                    else {
                        if (rows == null) {
                            rows = [];
                        }
                        resolve(rows);
                    }
                });
            });
        });
    }
    /**
     * GetTablesNames
     * @param mDb
     */
    async getTablesNames(mDb) {
        let sql = 'SELECT name FROM sqlite_master WHERE ';
        sql += "type='table' AND name NOT LIKE 'sync_table' ";
        sql += "AND name NOT LIKE '_temp_%' ";
        sql += "AND name NOT LIKE 'sqlite_%' ";
        sql += 'ORDER BY rootpage DESC;';
        const retArr = [];
        try {
            const retQuery = await this.queryAll(mDb, sql, []);
            for (const query of retQuery) {
                retArr.push(query.name);
            }
            return Promise.resolve(retArr);
        }
        catch (err) {
            return Promise.reject(`getTablesNames: ${err}`);
        }
    }
    /**
     * GetViewsNames
     * @param mDb
     */
    async getViewsNames(mDb) {
        let sql = 'SELECT name FROM sqlite_master WHERE ';
        sql += "type='view' AND name NOT LIKE 'sqlite_%' ";
        sql += 'ORDER BY rootpage DESC;';
        const retArr = [];
        try {
            const retQuery = await this.queryAll(mDb, sql, []);
            for (const query of retQuery) {
                retArr.push(query.name);
            }
            return Promise.resolve(retArr);
        }
        catch (err) {
            return Promise.reject(`getViewsNames: ${err}`);
        }
    }
    /**
     * isLastModified
     * @param db
     * @param isOpen
     */
    async isLastModified(db, isOpen) {
        if (!isOpen) {
            return Promise.reject('isLastModified: database not opened');
        }
        try {
            const tableList = await this.getTablesNames(db);
            for (const table of tableList) {
                const tableNamesTypes = await this.getTableColumnNamesTypes(db, table);
                const tableColumnNames = tableNamesTypes.names;
                if (tableColumnNames.includes('last_modified')) {
                    return Promise.resolve(true);
                }
            }
        }
        catch (err) {
            return Promise.reject(`isLastModified: ${err}`);
        }
    }
    /**
     * isSqlDeleted
     * @param db
     * @param isOpen
     */
    async isSqlDeleted(db, isOpen) {
        if (!isOpen) {
            return Promise.reject('isSqlDeleted: database not opened');
        }
        try {
            const tableList = await this.getTablesNames(db);
            for (const table of tableList) {
                const tableNamesTypes = await this.getTableColumnNamesTypes(db, table);
                const tableColumnNames = tableNamesTypes.names;
                if (tableColumnNames.includes('sql_deleted')) {
                    return Promise.resolve(true);
                }
            }
        }
        catch (err) {
            return Promise.reject(`isSqlDeleted: ${err}`);
        }
    }
    async getJournalMode(mDB) {
        let resQuery = [];
        let retMode = "delete";
        const query = `PRAGMA journal_mode;`;
        try {
            resQuery = await this.queryAll(mDB, query, []);
            if (resQuery.length === 1) {
                for (const query of resQuery) {
                    retMode = query.journal_mode;
                }
            }
            return retMode;
        }
        catch (err) {
            return Promise.reject('GetJournalMode: ' + `${err}`);
        }
    }
    /**
     * GetTableColumnNamesTypes
     * @param mDB
     * @param tableName
     */
    async getTableColumnNamesTypes(mDB, tableName) {
        let resQuery = [];
        const retNames = [];
        const retTypes = [];
        const query = `PRAGMA table_info('${tableName}');`;
        try {
            resQuery = await this.queryAll(mDB, query, []);
            if (resQuery.length > 0) {
                for (const query of resQuery) {
                    retNames.push(query.name);
                    retTypes.push(query.type);
                }
            }
            return Promise.resolve({ names: retNames, types: retTypes });
        }
        catch (err) {
            return Promise.reject('GetTableColumnNamesTypes: ' + `${err}`);
        }
    }
}
exports.UtilsSQLite = UtilsSQLite;
//# sourceMappingURL=utilsSQLite.js.map